import msgpack from 'msgpack-lite';
import store, { loadingActions } from '../../store';
import { fetchMsgPack as originalFetchMsgPack } from './utils';

const fetchMsgPackWithLoading = async (url, options = {}) => {
  store.dispatch(loadingActions.startRequest());
  try {
    return await originalFetchMsgPack(url, options);
  } finally {
    store.dispatch(loadingActions.finishRequest());
  }
};

// Function to fetch a single device with loading indicator
export const fetchDeviceWithLoading = async (deviceId) => {
  store.dispatch(loadingActions.startRequest());
  try {
    // Fetch the specific device by ID
    const url = `/api/devices/${deviceId}`;
    const response = await fetch(url, {
      headers: {
        Accept: 'application/msgpack',
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching device: ${response.status}`);
    }
    // Use the original msgpack decode logic
    const buffer = await response.arrayBuffer();
    const data = msgpack.decode(new Uint8Array(buffer));
    return data;
  } finally {
    store.dispatch(loadingActions.finishRequest());
  }
};

export default fetchMsgPackWithLoading;
